import { jsx } from 'react/jsx-runtime';
import { addPropsToSVG } from '../helpers/add-props-to-svg.esm.js';

const _SocialX = (props)=>jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: jsx("path", {
            fill: "currentColor",
            d: "m13.905 10.4695 7.4462-8.4695h-1.7643l-6.4685 7.3524-5.1626-7.3524h-5.9558l7.8086 11.1192-7.8086 8.8808h1.7643l6.8267-7.7662 5.4532 7.7662h5.9558l-8.095-11.5305Zm-2.4173 2.7473-.7923-1.1079-6.2949-8.8074h2.7103l5.0817 7.1105.789 1.1079 6.6046 9.242h-2.7103l-5.3881-7.5451Z",
            style: {
                vectorEffect: 'non-scaling-stroke'
            }
        })
    });
const SocialX = addPropsToSVG(_SocialX);

export { SocialX };
